import { render, staticRenderFns } from "./BeforeMount.vue?vue&type=template&id=1647a5d3&"
import script from "./BeforeMount.vue?vue&type=script&lang=js&"
export * from "./BeforeMount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports